const PALETTE = [
  "bg-indigo-500",
  "bg-purple-500",
  "bg-fuchsia-500",
  "bg-pink-500",
  "bg-rose-500",
  "bg-orange-500",
  "bg-amber-500",
  "bg-yellow-600",
  "bg-lime-600",
  "bg-emerald-500",
  "bg-teal-500",
  "bg-cyan-500",
  "bg-sky-500",
  "bg-blue-500",
];

function hash(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function avatarBgClass(seed: string | null | undefined): string {
  if (!seed) return "bg-muted";
  return PALETTE[hash(seed) % PALETTE.length];
}

export function initialsFor(
  name?: string | null,
  email?: string | null,
): string {
  const base = (name && name.trim()) || (email && email.split("@")[0]) || "?";
  const parts = base.split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function displayNameFor(
  name?: string | null,
  email?: string | null,
): string {
  if (name && name.trim()) return name.trim();
  if (email) return email;
  return "Unknown";
}
